import { fetch, fecthGet, fecthPost } from '@/hotelcem/apis/request'

const baseURL = `${process.env.VUE_APP_APIBASEURL}/api/v1`

export default {
  getRoutes(params) {
    return fetch({
      baseURL: baseURL,
      url: '/vocust-desk/menu/routes',
      method: 'GET',
      params,
    })
  },
  getHotelInfo(params) {
    return fecthGet('/cem/hotel/user/info2', params)
  },
  getIndustryList() {
    return fecthPost(
      '/hotel-info/user-hotel/industry-list',
      {},
      {
        baseURL: '/api/v1/cem-4x',
      }
    )
  },
  getHotelList(data) {
    // 这是全局的酒店筛选器使用,提供查多个和单个的方式
    return fecthPost('/cem/hotel/user/hotel/list2', data)
  },
  getRmsHotelList(data) {
    return fecthPost('/rms/user/hotel/list', data, {
      baseURL: `${process.env.VUE_APP_APIBASEURL}/api/v1`,
    })
  },
  // 获取短信验证码
  getValidateCode() {
    return fecthGet('/data-source/augment-verify/sendCode')
  },
  // 获取数据授权 token
  getPermissionToken(data) {
    return fecthPost('/data-source/augment-verify/compareCode', data)
  },
  // 获取租户信息
  getTennatInfo() {
    return fetch({
      baseURL,
      url: '/vocust-desk/tenant/detail',
    })
  },

  // 渠道验证状态查询
  getChannelVerifyStatus(data) {
    return fecthPost('/cem/hotel/channel/check/result', data)
    // return fecthPost('/cem/hotel/channel/check/state', data)
  },
  // 渠道验证 发送验证码
  getChannelVerifyCode(data) {
    return fecthPost('/cem/hotel/channel/check/send/code', data)
  },
  // 提交渠道验证
  submitChannelVerify(data) {
    return fecthPost('/cem/hotel/channel/check/submit', data)
  },
  // 小华获取token
  getAIToken(data = {}) {
    return fecthPost('/blade-auth/xiaohua/oauth/signature', data, {
      baseURL,
    })
  },
}
